import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ScrollService } from './core/services/scroll.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  title = 'ina-comunidades-web';

  // Inyectar ScrollService para inicializar el comportamiento de scroll
  private scrollService = inject(ScrollService);
}
